import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import * as api from "../api/api";
import "./LocationSelector.css";
import logo from "../assets/logo.png";
import LoadingSpinner from "./LoadingSpinner";
import LightRays from './LightRays';


const LocationSelector = () => {
  const navigate = useNavigate();

  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      try {
        const res = await api.getLocations();
        if (mounted && res) {
          setList(res);
          // if fewer than 2 enabled clinics, redirect directly to the single enabled clinic
          const enabled = res.filter((l) => l.enabled !== false);
          if (enabled.length === 1) {
            navigate(`/${enabled[0].slug}`);
            return;
          }
        }
      } catch (err) {
        console.error("Failed to load locations", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetch();
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="location-selector-page">
      <div className="location-hero">
          <LightRays
            raysOrigin="top-center"
            raysColor="#00ffff"
            raysSpeed={1.5}
            lightSpread={0.8}
            rayLength={1.2}
            followMouse={true}
            mouseInfluence={0.1}
            noiseAmount={0.1}
            distortion={0.05}
            className="custom-rays"
          />
        <div className="container">
          <div className="logo-section">
            <div className="logo-placeholder">
              <img
                src={logo}
                alt="Sharp Physio logo"
                style={{ width: 120, height: 120 }}
              />
            </div>
            <h1 className="heading-xl">SHARP PHYSIO</h1>
            <p
              className="body-lg"
              style={{ maxWidth: "600px", margin: "1rem auto" }}
            >
              Soins de kinésithérapie d'excellence à Paris
            </p>
          </div>

          <div className="locations-grid">
            {list.map((location) => (
              <div
                key={location.id}
                className="location-card"
                onClick={() => navigate(`/${location.slug}`)}
              >
                <div className="location-card-content">
                  <MapPin size={32} />
                  <h3 className="heading-md">{location.name}</h3>
                  <p className="body-md">{location.address}</p>
                  <button className="btn-secondary">
                    Découvrir <ArrowRight size={20} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSelector;
